import React from 'react';
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect';
import { toRgba } from 'utils/helpers';
import {
  selectChannelFormFirstLine,
  selectChannelFormSecondLine,
  selectChannelFormBackground,
  selectChannelThemes,
} from 'containers/ChannelsPage/selectors';
import { Embellishment } from 'containers/ChannelsPage/Forms/components';

import StartButton from 'components/Icon/StartButton';
import Device from 'components/Device';
import {
  Title,
  ButtonWrapper,
  PreviewScreen,
} from 'components/DevicePreview/styledComponents';
import { blurredPlaceholder } from 'components/DevicePreview';
import { DeviceWrapper } from 'containers/ChannelsPage/Forms/styledComponents';

const AppPreview =({
  shrink,
  themes,
  selectedTheme,
  themeInstance,
  firstLine,
  secondLine,
  appColor,
  backgroundColor,
  keydownIsActive,
  onShrinkChange,
  firstLineFieldName,
  secondLineFieldName,
}) => {
  const themeId                 =
    themeInstance && themeInstance.channel_theme_id;
  const theme                   = selectedTheme || themes[themeId];
  const firstLineSize           = theme && theme.first_line_max_size;
  const secondLineSize          = theme && theme.second_line_max_size;
  const defaultFirstLine        = theme && theme.default_first_line_text;
  const defaultSecondLine       = theme && theme.default_second_line_text;
  const defaultAppColor         = theme && theme.default_app_background_color;
  const appBackgroundUrl        = theme && theme.app_background_preview_url;
  const font                    = theme && theme.font;
  const maxFontWidth            = theme && theme.max_text_width;
  const lineHeight              = theme && theme.line_height;
  const secondLineFont          = theme && theme.second_line_font;
  const secondLineLetterSpacing = theme && theme.second_line_letter_spacing;
  const bgColor                 = toRgba(backgroundColor || defaultAppColor);
  const previewStyle            = {
    height: '100%',
    backgroundSize: [
      'cover',
      '105%'
    ],
    backgroundImage: [
      `linear-gradient(${bgColor} 0%, ${bgColor} 100%)`,
      `url(${blurredPlaceholder})`
    ],
  };
  const embellishmentProps = {
    font,
    firstLineSize,
    firstLineFieldName,
    maxFontWidth,
    keydownIsActive,
    firstLine,
    defaultFirstLine,
    secondLineSize,
    secondLineFieldName,
    secondLine,
    defaultSecondLine,
    lineHeight,
    secondLineFont,
    secondLineLetterSpacing,
    backgroundUrl: appBackgroundUrl,
    onShrinkChange
  };

  return (
    <DeviceWrapper shrink={shrink}>
      <Device>
        <PreviewScreen style={previewStyle}>
          <Embellishment isAppLogo {...embellishmentProps} />
          <Title>PHOTO BOOTH EXPERIENCE</Title>
          <ButtonWrapper>
            <StartButton />
          </ButtonWrapper>
        </PreviewScreen>
      </Device>
    </DeviceWrapper>
  );
}

const mapStateToProps = createStructuredSelector({
  firstLine: selectChannelFormFirstLine(),
  secondLine: selectChannelFormSecondLine(),
  appColor: selectChannelFormBackground(),
  themes: selectChannelThemes(),
});


export default connect(mapStateToProps)(AppPreview);



// WEBPACK FOOTER //
// ./src/containers/ChannelsPage/Forms/components/AppPreview.js